// api.ts file
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import initFirebaseClient from "../plugins/init-firebase-client.js";
import 'firebase/auth';
import { setupCSRFProtection } from '../services/security/csrf';
const { requestInterceptor } = setupCSRFProtection();

initFirebaseClient(); // Ensure Firebase is initialized

const auth = getAuth();

export const httpProxy = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL
    ? import.meta.env.VITE_BASE_URL + '/api/v1'
    : import.meta.env.VITE_BASE_URL_PROD + '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000,
});


export const httpInternal = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL
    ? import.meta.env.VITE_BASE_URL + '/internal'
    : import.meta.env.VITE_BASE_URL_PROD + '/internal',
  headers: {
    'Content-Type': 'application/json',  // Ensure Content-Type is set
  },
});

// Add interceptor to your axios instance
httpProxy.interceptors.request.use(requestInterceptor);

// Add a request interceptor to attach the token to every request
httpProxy.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;

    if (user) {
      // Get the latest ID token; Firebase caches tokens internally
      const token = await user.getIdToken(); // Do not force refresh here
      config.headers['Authorization'] = `${token}`;
    } else {
      // Handle the case where there is no authenticated user
      console.error('No authenticated user found.');
    }

    // Add impersonation header if present
    const impersonationEmail = localStorage.getItem('impersonationEmail');
    if (impersonationEmail) {
      config.headers['x-impersonate-email'] = impersonationEmail;
    }

    return config;
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);

// Social Media API functions
export const socialMediaAPI = {
  // Generate social media content
  generateSocialMedia: async (data: {
    articleId: string;
    firebaseUserUuid: string;
    article: any;
    socialMedia: 'x' | 'x_multithread' | 'instagram' | 'linkedin';
    threadLimit?: number; // Keep threadLimit for the API call
  }) => {
    const response = await httpProxy.post('/content/generate_social_media', data);
    return response.data;
  },

  // Get existing social media content for an article
  getSocialMediaInfo: async (articleId: string, firebaseUserUuid: string) => {
    const response = await httpProxy.post(`/article/${articleId}/social`, {
      firebaseUserUuid
    });
    return response.data;
  },
  getJobStatus: async (jobId: string) => {
    const response = await httpProxy.get(`/to_socials/job/${jobId}`);
    return response.data;
  }
};
